enum PreferencePermission {
  MARKETING = 'Marketing',
  ONLINE_STATEMENT_AVAILABILITY = 'OnlineStatementAvailability',
  PAPERLESS_BILLING = 'PaperlessBilling',
  PAYMENT_RECEIVED = 'PaymentReceived',
  PAYMENT_REMINDER = 'PaymentReminder',
}
enum PreferenceChannel {
  EMAIL = 'Email',
  SMS = 'Sms',
}

export { PreferencePermission, PreferenceChannel }
